import { useEffect, useState } from 'react';

import {
  WorkflowMapRecord,
  getWorkflowMap,
  refreshWorkflowMap,
  subscribeToWorkflowMap,
} from '../services/workflow';

/**
 * The app-wide workflow map (workflow type -> label/version/questionnaire info),
 * including dynamically registered questionnaire versions. Triggers a one-time
 * fetch of the MPA BP questionnaires and re-renders when new entries register.
 */
export function useWorkflowMap(): WorkflowMapRecord {
  const [map, setMap] = useState<WorkflowMapRecord>(getWorkflowMap);

  useEffect(() => {
    const unsubscribe = subscribeToWorkflowMap(setMap);
    refreshWorkflowMap();
    return unsubscribe;
  }, []);

  return map;
}
